import PaymentMethodSelection from './PaymentMethodSelection'

export default PaymentMethodSelection
